var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.821 40.333h-1.725l-.093-15.892h1.927l-.109 15.892zm-2.036 5.066c0-.343.114-.63.342-.862.228-.242.539-.363.933-.363.393 0 .704.12.932.363.239.231.358.519.358.861 0 .333-.12.615-.358.847-.228.222-.538.333-.932.333s-.705-.111-.933-.333a1.162 1.162 0 0 1-.342-.846z","fill":"#ffcb00","key":0}),React.createElement("path",{"d":"M68.168 54.906L37.153 2.648c-.96-1.617-3.346-1.617-4.306 0L1.832 54.906c-.976 1.645.258 3.659 2.153 3.659h62.03c1.895 0 3.129-2.014 2.153-3.659zM31.984 2.191c1.338-2.255 4.694-2.255 6.032 0l31.015 52.258c1.321 2.226-.316 5.051-3.016 5.051H3.985c-2.7 0-4.337-2.825-3.016-5.051L31.984 2.19z","fill":"#ffcb00","stroke":"#ffcb00","key":1})]);
}

Warning.defaultProps = {"viewBox":"0 0 70 60","width":"70","height":"60","fill":"none"};

module.exports = Warning;

Warning.default = Warning;
